// extracted by mini-css-extract-plugin
module.exports = {"container":"e_V2","link":"e_W2","imageContainer":"e_X2","author":"e_Y2","text":"e_Z2","buttonIcon":"e__2"};